import { Moment } from "moment";
import {
  DebitoCredito,
  LiquidacaoOpcao,
  MoedaInternacional,
  TipoEventoInternacional,
  TipoOperacaoInternacional,
} from "./enum";

// -------------------------------------------------------------------------------------------------
// Interfaces
// -------------------------------------------------------------------------------------------------

/*
 * Dados mínimos extraídos diretamente dos statements internacionais. Este é o formato que os
 * leitores (parsers) retornam.
 */
export interface IOperacaoLeitorInternacional {
  id: string;
  dataPregao: Moment;
  descricao: string;
  valorOperacao: number;
  debitoCredito: DebitoCredito;
  moeda: MoedaInternacional;
  uploadId: string;
  // Instituição financeira a que a operação pertence (ex.: Pictet, XP)
  instituicao?: string;
  quantidade?: number;
  // Leitores estruturados (IB) já entregam ativo e sentido; a IA só roda quando faltam
  ativo?: string;
  tipoOperacao?: TipoOperacaoInternacional;
  // Opção exercida/designada ou vencida (ver LiquidacaoOpcao)
  liquidacao?: LiquidacaoOpcao;
  // Ações por contrato (IB, Financial Instrument Information); ausente = 100
  multiplicador?: number;
}

/*
 * Versão enriquecida da operação internacional.  Herda todos os campos do leitor e adiciona os que
 * serão calculados posteriormente por um serviço de enriquecimento.
 */
export interface IOperacaoInternacional extends IOperacaoLeitorInternacional {
  tipoOperacao: TipoOperacaoInternacional;
  ativo?: string;
  // Valor da operação convertido para BRL (adicionado na fase de enriquecimento)
  valorOperacaoBRL?: number;
  // Só em CORPORATE_ACTION: quantidade nova = quantidade × fator
  fator?: number;
  evento?: TipoEventoInternacional;
  // Só em ALTERACAO_CODIGO: ticker que passa a valer a partir da data
  codigoNovo?: string;
  // Registrado pelo usuário na tela (uploadId "manual")
  manual?: boolean;
  // Linha igual a uma já importada de outro statement (período sobreposto): guarda o
  // statement que a comprova e não entra no cálculo enquanto ele existir
  duplicataDeUploadId?: string;
}

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

export class OperacaoInternacional implements IOperacaoInternacional {
  public id!: string;
  public dataPregao!: Moment;
  public descricao!: string;
  public valorOperacao!: number;
  public debitoCredito!: DebitoCredito;
  public moeda!: MoedaInternacional;
  public uploadId!: string;
  public instituicao?: string;
  public quantidade?: number;
  public liquidacao?: LiquidacaoOpcao;
  public multiplicador?: number;

  // Campos calculados / enriquecidos
  public tipoOperacao!: TipoOperacaoInternacional;
  public valorOperacaoBRL?: number;
  public ativo?: string;

  // Evento corporativo (CORPORATE_ACTION)
  public fator?: number;
  public evento?: TipoEventoInternacional;
  public codigoNovo?: string;
  public manual?: boolean;
  public duplicataDeUploadId?: string;

  constructor(param: IOperacaoInternacional) {
    Object.assign(this, param);
  }
}

export class OperacaoLeitorInternacional
  implements IOperacaoLeitorInternacional
{
  public id!: string;
  public dataPregao!: Moment;
  public descricao!: string;
  public valorOperacao!: number;
  public debitoCredito!: DebitoCredito;
  public moeda!: MoedaInternacional;
  public uploadId!: string;
  public instituicao?: string;
  public quantidade?: number;
  public ativo?: string;
  public tipoOperacao?: TipoOperacaoInternacional;
  public liquidacao?: LiquidacaoOpcao;
  public multiplicador?: number;

  constructor(param: IOperacaoLeitorInternacional) {
    Object.assign(this, param);
  }
}

// Mantém o export default para retro-compatibilidade
export default OperacaoInternacional;
